import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-receipt-cutoff" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "dropdown d-flex align-items-center" }
const _hoisted_12 = {
  href: "javascript:;",
  class: "dropdown-toggle middle-link",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_16 = { class: "setting-data" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_19 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_23 = { class: "d-block my-3" }
const _hoisted_24 = { class: "d-none d-md-block" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { colspan: "6" }
const _hoisted_32 = { class: "text-center py-2" }
const _hoisted_33 = { class: "d-none d-md-block" }
const _hoisted_34 = ["onClick", "title"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-fill" }, null, -1)
const _hoisted_37 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_38 = { style: {"padding":"5px 0"} }
const _hoisted_39 = { class: "bold" }
const _hoisted_40 = ["onClick", "title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-fill" }, null, -1)
const _hoisted_43 = { style: {"padding":"5px 0"} }
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { style: {"padding":"5px 0"} }
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = { style: {"padding":"5px 0"} }
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_53 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_58 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_59 = ["onClick", "title"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-all" }, null, -1)
const _hoisted_61 = {
  key: 2,
  class: "dropdown-divider"
}
const _hoisted_62 = ["onClick", "title"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wallet-fill" }, null, -1)
const _hoisted_64 = ["onClick", "title"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-lock-fill" }, null, -1)
const _hoisted_66 = {
  key: 5,
  class: "dropdown-divider"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_69 = { class: "d-none t-d-md-table-cell" }
const _hoisted_70 = { class: "d-none t-d-md-table-cell" }
const _hoisted_71 = { class: "d-none t-d-md-table-cell" }
const _hoisted_72 = { class: "d-none t-d-md-table-cell" }
const _hoisted_73 = { class: "d-none t-d-md-table-cell" }
const _hoisted_74 = { class: "sett-small-menu align-right" }
const _hoisted_75 = { class: "discl-menu dropdown" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_77 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { key: 1 }
const _hoisted_86 = ["onClick", "title"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-all" }, null, -1)
const _hoisted_88 = { key: 2 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { key: 3 }
const _hoisted_92 = ["onClick", "title"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wallet-fill" }, null, -1)
const _hoisted_94 = { key: 4 }
const _hoisted_95 = ["onClick", "title"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-lock-fill" }, null, -1)
const _hoisted_97 = { key: 5 }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { key: 6 }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_103 = { class: "col-md-6 col-sm-12" }
const _hoisted_104 = { class: "area-info" }
const _hoisted_105 = { class: "col-md-6 col-sm-12" }
const _hoisted_106 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_purchase_order_val = _resolveComponent("purchase-order-val")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_PurchaseOperationModal = _resolveComponent("PurchaseOperationModal")!
  const _component_PurchasePaytModal = _resolveComponent("PurchasePaytModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.purchases), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.selectedMonthLabel), 1),
                    _createElementVNode("ul", _hoisted_13, [
                      _createElementVNode("li", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfMonths, (oMonth) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["dropdown-item", {'active': oMonth.id == _ctx.selectedMonth}]),
                            href: "javascript:;",
                            key: oMonth.id,
                            onClick: ($event: any) => (_ctx.changeMonth(oMonth.id))
                          }, _toDisplayString(oMonth.label), 11, _hoisted_14))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_purchase_ops_msg), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.language.purchases), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddPurchaseOps(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfMonthPurchases.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_20),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.purchases), 1)
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.purch_order), 1)
                  ]),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.supplier), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.purch_date), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.purch_order_value), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.po_status), 1),
                  _hoisted_29
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfMonthPurchases.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (recProduct) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recProduct.IdPurchase
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddPurchaseOps(1, recProduct)),
                          title: _ctx.language.preview
                        }, _toDisplayString(recProduct.PurchaseOrderNbr), 9, _hoisted_34),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          to: `/app/products/purchases/${recProduct.PurchaseKey}/details/list`,
                          title: _ctx.language.show_details
                        }, {
                          default: _withCtx(() => [
                            _hoisted_35
                          ]),
                          _: 2
                        }, 1032, ["to", "title"]),
                        _createTextVNode("  "),
                        (recProduct.OperationStatus > 0)
                          ? (_openBlock(), _createBlock(_component_RouterLink, {
                              key: 0,
                              to: `/app/products/purchases/${recProduct.PurchaseKey}/payts/list`,
                              title: _ctx.language.show_payts
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 2
                            }, 1032, ["to", "title"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.language.code) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddPurchaseOps(1, recProduct)),
                              title: _ctx.language.preview
                            }, _toDisplayString(recProduct.PurchaseOrderNbr), 9, _hoisted_40),
                            _createTextVNode("  "),
                            _createVNode(_component_RouterLink, {
                              to: `/app/products/purchases/${recProduct.PurchaseKey}/details/list`,
                              title: _ctx.language.show_details
                            }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 2
                            }, 1032, ["to", "title"]),
                            _createTextVNode("  "),
                            (recProduct.OperationStatus > 0)
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 0,
                                  to: `/app/products/purchases/${recProduct.PurchaseKey}/payts/list`,
                                  title: _ctx.language.show_payts
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_42
                                  ]),
                                  _: 2
                                }, 1032, ["to", "title"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.language.supplier) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getSupplier(recProduct.SupplierKey)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.purch_date) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(recProduct.OperationDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.language.purch_order_value) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createVNode(_component_purchase_order_val, {
                              "currency-code": _ctx.currCode,
                              "purchase-key": recProduct.PurchaseKey
                            }, null, 8, ["currency-code", "purchase-key"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.language.po_status) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getPOstatus(recProduct.OperationStatus)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddPurchaseOps(1, recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_54),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deletePurchaseOpRecord(recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_55),
                            _hoisted_56,
                            _createVNode(_component_RouterLink, {
                              class: "dropdown-item py-2",
                              to: `/app/products/purchases/${recProduct.PurchaseKey}/details/list`,
                              title: _ctx.language.show_details
                            }, {
                              default: _withCtx(() => [
                                _hoisted_57,
                                _createTextVNode(" " + _toDisplayString(_ctx.language.details), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "title"]),
                            (recProduct.OperationStatus == 0)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_58))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus == 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.confirmPOrderOps(recProduct)),
                                  title: _ctx.language.confirm_msg
                                }, [
                                  _hoisted_60,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                ], 8, _hoisted_59))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus >= 1 && recProduct.OperationStatus < 4)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_61))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus >= 1 && recProduct.OperationStatus < 3)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.addPaytRecord(recProduct)),
                                  title: _ctx.language.process_order_paymet
                                }, [
                                  _hoisted_63,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.add_payt), 1)
                                ], 8, _hoisted_62))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus == 3)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 4,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.lockPurchaseOrder(recProduct)),
                                  title: _ctx.language.lock_purch_order_msg
                                }, [
                                  _hoisted_65,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.lock_purch_order), 1)
                                ], 8, _hoisted_64))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus !== 0)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_66))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus !== 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 6,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.printPurchaseOrder(recProduct))
                                }, [
                                  _hoisted_68,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                                ], 8, _hoisted_67))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.getSupplier(recProduct.SupplierKey)), 1),
                    _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.appFxs.formatDate(recProduct.OperationDate)), 1),
                    _createElementVNode("td", _hoisted_71, [
                      _createVNode(_component_purchase_order_val, {
                        "currency-code": _ctx.currCode,
                        "purchase-key": recProduct.PurchaseKey
                      }, null, 8, ["currency-code", "purchase-key"])
                    ]),
                    _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.getPOstatus(recProduct.OperationStatus)), 1),
                    _createElementVNode("td", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("span", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("ul", _hoisted_77, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.showAddPurchaseOps(1, recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_78)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deletePurchaseOpRecord(recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_79)
                            ]),
                            _hoisted_80,
                            _createElementVNode("li", null, [
                              _createVNode(_component_RouterLink, {
                                class: "dropdown-item py-2",
                                to: `/app/products/purchases/${recProduct.PurchaseKey}/details/list`,
                                title: _ctx.language.show_details
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_81,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.details), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "title"])
                            ]),
                            (recProduct.OperationStatus == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_82, _hoisted_84))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_85, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.confirmPOrderOps(recProduct)),
                                    title: _ctx.language.confirm_msg
                                  }, [
                                    _hoisted_87,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                  ], 8, _hoisted_86)
                                ]))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus >= 1 && recProduct.OperationStatus <4)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_88, _hoisted_90))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus >= 1 && recProduct.OperationStatus < 3)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_91, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.addPaytRecord(recProduct)),
                                    title: _ctx.language.confirm_msg
                                  }, [
                                    _hoisted_93,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.add_payt), 1)
                                  ], 8, _hoisted_92)
                                ]))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus == 3)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_94, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.lockPurchaseOrder(recProduct)),
                                    title: _ctx.language.lock_purch_order_msg
                                  }, [
                                    _hoisted_96,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.lock_purch_order), 1)
                                  ], 8, _hoisted_95)
                                ]))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus !== 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_97, _hoisted_99))
                              : _createCommentVNode("", true),
                            (recProduct.OperationStatus !== 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_100, [
                                  (recProduct.OperationStatus !== 0)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "dropdown-item py-2",
                                        href: "javascript:;",
                                        onClick: ($event: any) => (_ctx.printPurchaseOrder(recProduct))
                                      }, [
                                        _hoisted_102,
                                        _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                                      ], 8, _hoisted_101))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfMonthPurchases.length==0}])
            }, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfMonthPurchases.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("nav", _hoisted_106, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_PurchaseOperationModal, {
        visible: _ctx.isPurchOpModalVis,
        initialValues: _ctx.purchaseInitVals,
        "list-suppliers": _ctx.listOfSuppliers,
        recordStatus: _ctx.purchRecStatus,
        onCloseForm: _ctx.onPurchaseModalClose,
        "selected-month": _ctx.selectedMonth
      }, null, 8, ["visible", "initialValues", "list-suppliers", "recordStatus", "onCloseForm", "selected-month"]),
      _createVNode(_component_PurchasePaytModal, {
        visible: _ctx.isPaytDlgVisible,
        initialValues: _ctx.paytInitialValues,
        recordStatus: _ctx.detailRecordStatus,
        remainAmt: _ctx.remainPaytAmt,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "remainAmt", "onCloseForm"])
    ]))
  ], 64))
}